import { Any } from '@/shared/constant/any';
import { i18n, type LocaleType } from '@/shared/i18n/i18n';
import type { SupportedLocale } from '@/shared/i18n/SupportedLocale';
import { createContextStore } from '@/shared/util/createContextStore';

export type ClientI18nState = {
  clientLocale: SupportedLocale;
};

export type ClientI18nAction = {
  clientI18n: (key: keyof LocaleType, params?: Record<string, string>) => string;
};

export const ClientI18nInitialState: ClientI18nState = {
  ...Any,
};

const [ClientI18nModelStoreProvider, useClientI18nModelStore] = createContextStore<
  ClientI18nState,
  ClientI18nAction
>(
  (_set, get) => ({
    ...ClientI18nInitialState,
    clientI18n: (key, params = {}) => {
      const { clientLocale } = get();
      const result = i18n(key, clientLocale, params) ?? key;

      return result;
    },
  }),
  false,
);

export { ClientI18nModelStoreProvider, useClientI18nModelStore };
